import { render } from "./editarRecepcion.vue?vue&type=template&id=debf6d18&scoped=true"
import script from "./editarRecepcion.vue?vue&type=script&lang=js"
export * from "./editarRecepcion.vue?vue&type=script&lang=js"

import "./editarRecepcion.vue?vue&type=style&index=0&id=debf6d18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-debf6d18"]])

export default __exports__